"use strict";

var _interopRequireDefault = require("/Users/xudong/bs_workspace/RuoYi-Vue/hss_-warning_-h5/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.resetRouter = resetRouter;
exports.routes = void 0;
require("core-js/modules/es.object.to-string.js");
var _interopRequireWildcard2 = _interopRequireDefault(require("/Users/xudong/bs_workspace/RuoYi-Vue/hss_-warning_-h5/node_modules/@babel/runtime/helpers/interopRequireWildcard.js"));
var _vue = _interopRequireDefault(require("vue"));
var _vueRouter = _interopRequireDefault(require("vue-router"));
var _layout = _interopRequireDefault(require("@/layout"));
var _NotFound = _interopRequireDefault(require("@/layout/components/NotFound"));
_vue.default.use(_vueRouter.default);
var routes = exports.routes = [{
  path: '/redirect',
  component: _layout.default,
  children: [{
    path: '/redirect/:path(.*)',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/pages/redirect/index'));
      });
    }
  }]
}, {
  path: '/404',
  name: 'NotFound',
  component: _NotFound.default
}, {
  path: '/',
  component: _layout.default,
  redirect: '/home',
  children: [{
    path: 'home',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/pages/home/index'));
      });
    },
    name: 'Home',
    meta: {
      title: '校园安全数据一览'
    }
  }]
},
// 康复绿通
{
  path: '',
  component: _layout.default,
  redirect: '/kflt',
  children: [{
    path: 'kflt',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/pages/kflt/index'));
      });
    },
    name: 'Kflt',
    meta: {
      title: '康复绿通'
    }
  }]
},
// 私人康复师
{
  path: '',
  component: _layout.default,
  redirect: '/srkfs',
  children: [{
    path: 'srkfs',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/pages/srkfs/index'));
      });
    },
    name: 'Srkfs',
    meta: {
      title: '私人康复师'
    }
  }]
},
// 住院减免
{
  path: '',
  component: _layout.default,
  redirect: '/zyjm',
  children: [{
    path: 'zyjm',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/pages/zyjm/index'));
      });
    },
    name: 'Zyjm',
    meta: {
      title: '住院减免'
    }
  }]
},
// 远程康复
{
  path: '',
  component: _layout.default,
  redirect: '/yckf',
  children: [{
    path: 'yckf',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/pages/yckf/index'));
      });
    },
    name: 'Yckf',
    meta: {
      title: '远程康复'
    }
  }]
}];
var createRouter = function createRouter() {
  return new _vueRouter.default({
    mode: 'hash',
    scrollBehavior: function scrollBehavior() {
      return {
        y: 0
      };
    },
    routes: routes
  });
};
var router = createRouter();
function resetRouter() {
  var newRouter = createRouter();
  router.matcher = newRouter.matcher;
}
var _default = exports.default = router;